
import { defineComponent, PropType } from 'vue'
import { iDimensionFilter, iHierarchy } from '../../../HierarchyManagement'
import moment from 'moment'
import Calendar from 'primevue/calendar'
import Checkbox from 'primevue/checkbox'
import Card from 'primevue/card'

const deepcopy = require('deepcopy')

export default defineComponent({
    name: 'hierarchy-management-dimensions-filter-card',
    components: { Calendar, Checkbox, Card },
    props: { dimensionFilters: { type: Array as PropType<iDimensionFilter[]> }, selectedHierarchy: { type: Object as PropType<iHierarchy | null> } },
    emits: ['applyFilters'],
    data() {
        return {
            filters: [] as iDimensionFilter[],
            showMissingElements: false,
            expandFilterCard: false
        }
    },
    watch: {
        dimensionFilters() {
            this.loadFilters()
        }
    },
    async created() {
        this.loadFilters()
    },
    methods: {
        loadFilters() {
            this.filters = this.dimensionFilters as iDimensionFilter[]
        },
        applyFilters() {
            let tempFilters = deepcopy(this.filters)
            tempFilters = tempFilters.filter((filter: iDimensionFilter) => filter.VALUE && filter.VALUE !== '')
            tempFilters.forEach((filter: iDimensionFilter) => {
                if (filter.TYPE === 'Date') {
                    filter.VALUE = moment(filter.VALUE).format('YYYY-MM-DD')
                }
            })
            this.$emit('applyFilters', { filters: tempFilters, showMissingElements: this.showMissingElements })
        },
        resetFilters() {
            this.showMissingElements = false
            this.filters?.forEach((filter: iDimensionFilter) => (filter.VALUE = ''))
            this.$emit('applyFilters', { filters: [], showMissingElements: this.showMissingElements })
        }
    }
})
